import {IconModel} from "Core/Controls/BaseControl/Models/IconModel";

export class SubAdministrationDtoModel {
    TableId: number;
    Name: string;
    Icon: IconModel;
}